export default "__VITE_ASSET__gVY$rezm__"